import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    getAutoSubsPlayers,
} from '../../helper-common';

class AutoSubsPlayers extends Component {
    getHeader = () => {
        return <div className="si-list-item si-list-header">
            <div className="si-subs-out">
                <i className="icon-ucl-substitute-out"></i>
                <span>{this.props.trans.out}</span>
            </div>
            <div className="si-subs-in">
                <i className="icon-ucl-substitute-in"></i>
                <span>{this.props.trans.in}</span>
            </div>
        </div>
    }
    getLeftColumn = (obj) => {
        const In = obj["in"];
        const Out = obj["out"];
        const block = In.map(function (pName, index) {
            return (
                (index%2===0) ? <div key={"subLeft"+index} className="si-list-item si-list-text">
                    <span>{Out[index]}</span>
                    <span>{pName}</span>
                </div> : null
            )
        });
        
        return <div className="si-flexBox si-subs-list si-left-list">
            {this.getHeader()}
            {block}
        </div>
    }

    getRightColumn = (obj) => {
        const In = obj["in"];
        const Out = obj["out"];
        const block = In.map(function (pName, index) {
            return (
                (index%2===1) ? <div key={"subLeft"+index} className="si-list-item si-list-text">
                    <span>{Out[index]}</span>
                    <span>{pName}</span>
                </div> : null
            )
        });

        return <div className="si-flexBox si-subs-list si-right-list">
            {this.getHeader()}
            {block}
        </div>
    }

    render() {
        const { teamData, trans } = this.props;
        if(!teamData){
            return null;
        }
        const autoSubsPlyr = getAutoSubsPlayers(teamData);
        return (
            (autoSubsPlyr.subsCount>0) ? <div className="si-plyr-subs-info">
                <div className="si-info-block si-subs-info">
                    <span className="si-info-title">{trans.yourSubs}</span>
                    <div className="si-subs-body">
                        {this.getLeftColumn(autoSubsPlyr)}
                        {(autoSubsPlyr.subsCount>1 ? this.getRightColumn(autoSubsPlyr) : null)}
                    </div>
                </div>
            </div> : null
        )
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        teamData: state.formationData.teamData,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(AutoSubsPlayers);


// WEBPACK FOOTER //
// ./src/components/manage-team/Auto-Substitution-Players.js